import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  PictureComponent,
  PictureLayout,
  PictureResizeFit,
} from '@freelancer/ui/picture';
import { LoadingTemplateComponent } from '../loading-template';

@Component({
  standalone: true,
  imports: [LoadingTemplateComponent, PictureComponent],
  selector: 'fl-thumbnail-viewer-image',
  template: `
    @if (loading) {
      <fl-loading-template class="ThumbnailLoader" />
    }
    <fl-picture
      class="ThumbnailImage"
      [class.IsHidden]="loading"
      [alt]="alt"
      [fixedAspectRatio]="true"
      [height]="height"
      [layout]="layout"
      [resizeFit]="resizeFit"
      [src]="src"
      [width]="width"
      (imageLoaded)="handleImageLoaded()"
    ></fl-picture>
  `,
  styleUrls: ['./thumbnail-viewer-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbnailViewerImageComponent {
  loading = true;

  @Input() alt: string;
  @Input() src: string;
  @Input() resizeFit?: PictureResizeFit;
  @Input() width?: number;
  @Input() height?: number;
  @Input() layout?: PictureLayout;

  handleImageLoaded(): void {
    this.loading = false;
  }
}
